/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import Typography, { fontStyle } from 'core/ui/Typography';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import SelectBox from 'core/ui/SelectBox';
import Radio from 'core/ui/Radio';
import TextAreaFieldRounded from 'core/ui/TextAreaFieldRounded';
import { streamCosts } from 'core/utils/consts';
import { currency } from 'core/utils/formatters';
import SelectBoxObject from 'core/ui/SelectBoxObject';
import Paper from 'core/ui/Paper';
import Grid from 'core/ui/Grid';
import { CompetitionContext } from '../index';

export default () => {
  const { t } = useTranslation();
  const formContext = useContext(CompetitionContext);

  const taxPercent =
    formContext?.selectedChannel?.channelsTaxes?.find(
      (x) => x.id == formContext.watch('channelsTaxId'),
    )?.percentAmount || 0;

  const streamFee = () => {
    if (formContext.watch('online')) {
      return streamCosts.PERC_STREAM_COMPETITION;
    }
    return 1;
  };

  const calculateHostRevenue = (amount) => {
    if (formContext.watch('useTax') && Number(taxPercent) > 0) {
      const taxAmount = (Number(amount) / 100) * Number(taxPercent);
      return Number(amount) * streamFee() + taxAmount;
    }

    return amount * streamFee();
  };

  const calculateChargeCost = (amount) => {
    const streamAmount = Number(amount) * (1 - streamFee());

    if (formContext.watch('useTax') && Number(taxPercent) > 0) {
      const taxAmount = (Number(amount) / 100) * Number(taxPercent);
      return Number(amount) + streamAmount + taxAmount;
    }

    return Number(amount) + streamAmount;
  };

  return (
    <>
      <Box display="flex" className="gap-10" flexWrap="wrap" mb={2}>
        {formContext?.selectedChannel && (
          <Box>
            <Paper p={2}>
              <Typography style={fontStyle.label} variant="body1">
                {t('competition.label.useTax').toUpperCase()}
              </Typography>
              <Box display="flex">
                <Radio
                  label={
                    <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                      {t(`button.no`).toUpperCase()}
                    </Typography>
                  }
                  onClick={() => formContext.setValue('useTax', false)}
                  checked={!formContext.watch('useTax')}
                />
                <Box ml={3}>
                  <Radio
                    label={
                      <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                        {t(`button.yes`).toUpperCase()}
                      </Typography>
                    }
                    onClick={() => formContext.setValue('useTax', true)}
                    checked={!!formContext.watch('useTax')}
                  />
                </Box>
              </Box>

              {formContext.watch('useTax') && (
                <Box flexGrow={1}>
                  <SelectBoxObject
                    emptyItem
                    emptyValue={null}
                    options={formContext?.selectedChannel?.channelsTaxes}
                    value={formContext?.watch('channelsTaxId')}
                    setValue={(v) => formContext.setValue('channelsTaxId', v)}
                    label={t('channel.label.selectTheTax').toUpperCase()}
                    bordered
                  />
                </Box>
              )}
            </Paper>
          </Box>
        )}

        {!formContext?.watch('payPerDivision') ? (
          <>
            {(formContext?.watch('eventType') === 'individual' ||
              formContext?.watch('eventType') === 'both') && (
              <Box>
                <Paper p={2}>
                  <TextFieldRounded
                    name="cost"
                    type="number"
                    pattern="[0-9]*"
                    error={formContext.errors.cost}
                    placeholder={t('competition.label.cost')}
                    label={t('competition.label.cost').toUpperCase()}
                    inputRef={formContext.register({ required: t('competition.validation.cost') })}
                    required
                    currency
                    currencySymbol={formContext?.currency?.symbol}
                    bordered
                    // disabled={formContext.competition.started}
                  />
                  <Box>
                    {formContext.watch('useTax') && (
                      <Typography mx={2} variant="caption" component="p">
                        {t('competition.label.cost.charge')}:&nbsp;
                        {currency(calculateChargeCost(formContext.watch('cost')))}
                        /Person
                      </Typography>
                    )}
                    <Typography mx={2} variant="caption" component="p">
                      {t('competition.label.cost.host')}:&nbsp;
                      {currency(calculateHostRevenue(formContext.watch('cost')))}
                      /Person
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            )}
            {(formContext.watch('eventType') === 'team' ||
              formContext?.watch('eventType') === 'both') && (
              <Box>
                <Paper p={2}>
                  <Box display="flex">
                    <Box>
                      <TextFieldRounded
                        name="costTeam"
                        type="number"
                        pattern="[0-9]*"
                        error={formContext.errors.cost}
                        placeholder={t('competition.label.cost')}
                        label={t('competition.label.costTeam').toUpperCase()}
                        inputRef={formContext.register({
                          required: t('competition.validation.costTeam'),
                        })}
                        required
                        currency
                        currencySymbol={formContext?.currency?.symbol}
                        bordered
                        // disabled={formContext.competition.started}
                      />
                    </Box>
                    <Box ml={2}>
                      <SelectBox
                        error={formContext.errors.teamSize}
                        label={t('competition.label.teamSize').toUpperCase()}
                        options={['2', '3', '4', '5', '6']}
                        setValue={(v) => formContext.setValue('teamSize', v)}
                        value={
                          formContext.watch('teamSize') ? `${formContext.watch('teamSize')}` : '2'
                        }
                        required
                        bordered
                      />
                    </Box>
                  </Box>
                  <Box>
                    {formContext.watch('useTax') && (
                      <Typography mx={2} variant="caption" component="p">
                        {t('competition.label.cost.charge')}:&nbsp;
                        {currency(calculateChargeCost(formContext.watch('costTeam')))}
                        /Person
                      </Typography>
                    )}
                    <Typography mx={2} variant="caption" component="p">
                      {t('competition.label.cost.host')}:&nbsp;
                      {currency(calculateHostRevenue(formContext.watch('costTeam')))}
                      /Person
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            )}
          </>
        ) : (
          <>
            {(formContext.watch('eventType') === 'team' ||
              formContext?.watch('eventType') === 'both') && (
              <Box ml={2}>
                <SelectBox
                  error={formContext.errors.teamSize}
                  label={t('competition.label.teamSize').toUpperCase()}
                  options={['2', '3', '4', '5', '6']}
                  setValue={(v) => formContext.setValue('teamSize', v)}
                  value={formContext.watch('teamSize') ? `${formContext.watch('teamSize')}` : '2'}
                  required
                  bordered
                />
              </Box>
            )}
          </>
        )}

        <Paper p={2}>
          <Typography style={fontStyle.label} variant="body1">
            {t('competition.label.donations').toUpperCase()}
          </Typography>
          <Box display="flex">
            <Radio
              label={
                <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                  {t(`button.yes`).toUpperCase()}
                </Typography>
              }
              onClick={() => formContext.setValue('donations', true)}
              checked={!!formContext.watch('donations')}
            />
            <Box ml={3}>
              <Radio
                label={
                  <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                    {t(`button.no`).toUpperCase()}
                  </Typography>
                }
                onClick={() => formContext.setValue('donations', false)}
                checked={!formContext.watch('donations')}
              />
            </Box>
          </Box>
          {!!formContext.watch('donations') && (
            <Box mt={1}>
              <TextAreaFieldRounded
                error={formContext.errors.costAffiliate}
                placeholder={t('competition.label.donationsDescription')}
                label={t('competition.label.donationsDescription').toUpperCase()}
                value={formContext.watch('donationsDescription')}
                onChange={(v) => formContext.setValue('donationsDescription', v)}
                bordered
              />
            </Box>
          )}
        </Paper>
      </Box>

      <Grid container spacing={5}>
        <Grid item xs={12} md={6}>
          <Paper p={2}>
            <Typography style={fontStyle.label} variant="body1">
              {t('competition.label.hasAffiliate').toUpperCase()}
            </Typography>
            <Box display="flex">
              <Radio
                label={
                  <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                    {t(`button.no`).toUpperCase()}
                  </Typography>
                }
                onClick={() => formContext.setValue('hasAffiliate', false)}
                checked={
                  formContext.watch('hasAffiliate') === false ||
                  formContext.watch('hasAffiliate') === undefined
                }
              />
              <Box ml={3}>
                <Radio
                  label={
                    <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                      {t(`button.yes`).toUpperCase()}
                    </Typography>
                  }
                  onClick={() => formContext.setValue('hasAffiliate', true)}
                  checked={formContext.watch('hasAffiliate') === true}
                />
              </Box>
            </Box>
            <Typography variant="body2" className="roboto-regular">
              {t('competition.subtextAffiliate.header')}
            </Typography>
          </Paper>
        </Grid>

        {formContext.watch('hasAffiliate') && (
          <Grid item xs={12} md={6}>
            <Paper p={2}>
              <Box>
                <TextFieldRounded
                  name="costAffiliate"
                  type="number"
                  pattern="[0-9]*"
                  error={formContext.errors.costAffiliate}
                  placeholder={t('competition.label.costAffiliate')}
                  label={t('competition.label.costAffiliate').toUpperCase()}
                  inputRef={formContext.register({
                    required:
                      formContext.watch('hasAffiliate') === true
                        ? t('competition.validation.costAffiliate')
                        : false,
                  })}
                  required
                  currency
                  disabled={formContext.competition.started}
                />
                <Typography mx={2} variant="caption">
                  {t('competition.label.cost.host')}:&nbsp;
                  {currency(calculateHostRevenue(formContext.watch('costAffiliate')))}
                  /Affiliate Gym
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>
    </>
  );
};
